// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

import iconEfectySrc from './icon-efecty.svg';
import ChevronRightBlue from './chevron-right-blue.svg';

import { theme } from '../../../../../../commons/theme';

export function EfectyMapLink(): Node {
  return(
    <Link href="https://www.efecty.com.co/web/puntos-de-atencion" target="_blank">
      <Image src={iconEfectySrc} alt="Efecty" />
      <LinkText>Haz click para ver el punto Efecty más cercano para realizar tu pago.</LinkText>
      <img src={ChevronRightBlue} alt="Ir al sitio web"/>
    </Link>
  );
}

const LinkText = styled.p`
  flex: 0 1 auto;
  margin: 0 7px 0 14px;
  line-height: 1.3;
  font-size: 14px;
`;

const Link = styled.a`
  display: flex;
  text-decoration: none;
  padding: 16px;
  border-radius: 5px;
  border: 1px solid ${theme.colors.gray(65)};
  justify-content: space-between;
  align-items: center;
`;

const Image = styled.img`
  flex: 0 0 auto;
  height: 100%;
`;
